export const BASE_ROUTE = '';
export const FLOW_ROUTE_WITHOUT_FLOW_ID = '/:learningLanguage';
export const FLOW_ROUTE = '/:learningLanguage/:flowId';
export const NODE_ROUTE = `${FLOW_ROUTE}/node/:nodeId`;
export const FLOW_ROUTE_WITH_POST_VERIFICATION_FLOW_ID = `${FLOW_ROUTE}/:postVerificationFlowId`;
export const NODE_ROUTE_WITH_POST_VERIFICATION_FLOW_ID = `${FLOW_ROUTE_WITH_POST_VERIFICATION_FLOW_ID}/node/:nodeId`;
